import { useId, useMemo } from "react";

import NotFoundPage from "components/error/NotFoundPage";
import PageLayoutSkeleton from "components/PageLayoutSkeleton";
import { getSearchQuery } from "components/SearchInput/helpers";
import useErrorHandle from "hooks/useErrorHandle";
import useURLParams from "hooks/useURLParams";

import useTemplates from "../TemplatesWorkbench/hooks/useTemplates";
import TemplatesPageLayout from "./PageLayout";
import TemplateCard from "./TemplateCard";
import TemplatesEmpty from "./Empty";
import styles from "./styles.module.css";

const TemplatesMarketplace = () => {
  const urlParams = useURLParams();
  const searchInput = getSearchQuery(urlParams);
  const titleId = useId();

  const { initialLoading, error, templates, noResults } = useTemplates();

  // Only show templates that have at least one published version
  const publishedTemplates = useMemo(
    () =>
      templates.filter(
        (template) => template.latestVersion != null && template.latestVersion.version !== ""
      ),
    [templates]
  );

  const hasPublishedTemplates = publishedTemplates.length > 0;

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (initialLoading) {
    return (
      <TemplatesPageLayout titleId={titleId}>
        <PageLayoutSkeleton />
      </TemplatesPageLayout>
    );
  }

  if (noResults) {
    return <NotFoundPage />;
  }

  const hasNoResultsWithFiltering = searchInput.length > 0;

  return (
    <TemplatesPageLayout titleId={titleId}>
      {!hasPublishedTemplates && <TemplatesEmpty hasNoResults={hasNoResultsWithFiltering} />}

      {hasPublishedTemplates && (
        <div className={styles.grid}>
          {publishedTemplates.map((template) => (
            <TemplateCard key={template.id} template={template} />
          ))}
        </div>
      )}
    </TemplatesPageLayout>
  );
};

export default TemplatesMarketplace;
